'use client';

import { Skeleton } from '@shared/components/shadcn';
import { ScratchcardsCardGrid } from '../ScratchcardsCardGrid/ScratchcardsCardGrid';
import { useScratchcardsByCategory } from '../hooks/useScratchcardsByCategory/useScratchcardsByCategory';

type ScratchcardsListSectionProps = {
  namespace: string;
  className?: string;
  limit: number;
};

function ScratchcardsListSection({ namespace, className, limit }: ScratchcardsListSectionProps) {
  const { data, isLoading, error } = useScratchcardsByCategory({
    limit,
  });
  const scratchcards = data ?? [];
  const visibleScratchcards = scratchcards.slice(0, limit);

  if (error) return null;
  if (!isLoading && scratchcards.length === 0) return null;

  return (
    <section className={className} data-testid="scratchcards-list-section">
      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-track-container="Games">
          {Array.from({ length: limit }, (_, index) => (
            <Skeleton key={index} data-testid="scratchcard-skeleton" className="h-28.5 w-full rounded-lg" />
          ))}
        </div>
      ) : (
        <ScratchcardsCardGrid scratchcards={visibleScratchcards} namespace={namespace} data-track-container="Games" />
      )}
    </section>
  );
}

export { ScratchcardsListSection, type ScratchcardsListSectionProps };
